import script from "./OurServices.vue?vue&type=script&setup=true&lang=ts"
export * from "./OurServices.vue?vue&type=script&setup=true&lang=ts"

import "./OurServices.vue?vue&type=style&index=0&id=c16efe38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c16efe38"]])

export default __exports__